/** Query-key root for all asset resources. */
export const ASSETS_KEY = 'assets' as const;

/** How long fetched asset data is considered fresh. */
export const ASSETS_STALE_TIME = 5 * 60_000;

/** Backend-default page size for the cross-scope accepted-asset catalog. */
export const ASSET_CATALOG_PAGE_SIZE = 100;

/**
 * Max size of an asset-key search term. Sourced from the backend contract — the
 * global `GET /assets` rejects a `q` over 64 UTF-8 bytes with `400`. Guarded
 * client-side so a blank/oversized term disables the query instead of round-tripping
 * to a 400; the backend remains the authoritative enforcer.
 */
export const ASSET_KEY_QUERY_MAX_BYTES = 64;

/** Poll active preview generation only while its dialog stays open. */
export const ASSET_PREVIEW_POLL_MS = 2_500;

/** Refresh short-lived playback URLs one minute before expiry. */
export const ASSET_PREVIEW_URL_REFRESH_LEAD_MS = 60_000;

/** Each preview sample represents roughly 2.5 seconds of the source asset. */
export const ASSET_PREVIEW_DEFAULT_PLAYBACK_RATE = 4;
